<template>
    <div>
        <b-card-title class="text-muted text-center">Reporte general pendientes de pago</b-card-title>
        <template v-if="!loadingexcelreport">
            <div class="text-center">
                <b-button variant="primary" @click="downloadReportExcel()"><i class="fa fa-file-excel"></i> Descargar Reporte</b-button>
            </div>
        </template>
        <template v-else>
            <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong> Cargando...</strong>
            </div>
        </template>
    </div>
</template>

<script>
import axios from 'axios'
import download from 'downloadjs'
    export default {
        name: 'PendientePago',
        data: () => {
            return {
                loadingexcelreport: false
            }
        },
        methods: {
            downloadReportExcel: function() {
                let file = ''
                let tag = document.createElement('i')
                tag.classList.add('fa','fa-spin', 'fa-spinner')
                let name = 'Reporte general de deudores' + '.xlsx'            
                this.loadingexcelreport = true
                this.$swal({
                    title: 'Procesando Descarga',
                    content: tag,
                    icon: 'info',
                    buttons: false,
                    dangerMode: false
                })
                axios
                .post(process.env.VUE_APP_API_URL + 'documentoscredito/emisor/reporte/pendientes/excel', {
                    token: this.$store.getters.userToken   
                })
                .then(response => (
                file = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'+ response.data.base64,
                this.loadingexcelreport = false,               
                download(file, name,'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'),
                this.$swal.close()
                ))
                .catch(error => {this.loadingexcelreport = false, this.$swal.close()})
            },
        }
    }
</script>

<style lang="scss" scoped>

</style>